import { render } from "./StructureViewer.vue?vue&type=template&id=2e3c4a9c&scoped=true"
import script from "./StructureViewer.vue?vue&type=script&lang=js"
export * from "./StructureViewer.vue?vue&type=script&lang=js"

import "./StructureViewer.vue?vue&type=style&index=0&id=2e3c4a9c&scoped=true&lang=scss"
import "./StructureViewer.vue?vue&type=style&index=1&id=2e3c4a9c&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3c4a9c"]])

export default __exports__